import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import db from "./Firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Moment from "moment";
import { extendMoment } from "moment-range";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


function GrowAllData() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [personalDetails, setPersonalDetails] = useState({});
    useEffect(() => {
        // Fetch enrolled courses
        const unsubscribe = db.collection("nv_users_saved_draft")
            .orderBy("createdAt", "desc")
            .onSnapshot((snapshot) => {
                const courses = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));
                setData(courses);
                fetchPersonalDetails(courses);
            });

        return () => unsubscribe();
    }, []);



    // **Fetch personal details for all phone numbers**
    const fetchPersonalDetails = async (courses) => {
        const phoneNumbers = [...new Set(courses.map(({ data }) => data.phone_no))];

        if (phoneNumbers.length === 0) return; // No phone numbers to fetch

        let detailsMap = {};
        const batchSize = 10; // Firestore 'in' query limit

        // **Fetch in batches of 10**
        for (let i = 0; i < phoneNumbers.length; i += batchSize) {
            const batch = phoneNumbers.slice(i, i + batchSize);
            const q = query(collection(db, "personal_details"), where("phone_no", "in", batch));

            const snapshot = await getDocs(q);
            snapshot.docs.forEach((doc) => {
                const d = doc.data();
                detailsMap[d.phone_no] = d.full_name || "N/A"; // Default if missing
            });
        }

        setPersonalDetails(detailsMap);
    };



    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">

                <div className="card-header pb-0 px-3 d-flex justify-content-between">
                    <h6 className="mb-2">Grow Data</h6>
                    <Link to="/grow_data">
                        <button className="btn btn-success btn-sm" >
                            Grow Ready Made Data
                        </button>
                    </Link>
                </div>

                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Image</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Type</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(({ id, data }, index) => (
                                <tr key={id}>
                                    <td>{index + 1}</td>
                                    <td><img src={data.backgroundImage == "" ? "" : data.backgroundImage} className="me-3" style={{ height: "4rem" }} alt="Background" /></td>
                                    <td>{personalDetails[data.phone_no] || "Loading..."}</td>
                                    <td>{data.phone_no}</td>
                                    <td>{data.type}</td>
                                    <td>{moment(data.createdAt, moment.ISO_8601).format("Do MMMM YYYY")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default GrowAllData;